// Mock notification data matching the design
// Replace with API calls when backend endpoints are ready

export const NOTIFICATION_TYPES = {
  SUCCESS: 'Success',
  WARNING: 'Warning',
  INFO: 'Info',
  USER: 'User',
};

export const mockNotifications = [
  // Today
  {
    id: 1,
    title: 'Revenue Milestone',
    description: "You've earned $2,340 this month — 28% more than last month!",
    type: NOTIFICATION_TYPES.SUCCESS,
    time: '2 min ago',
    date: 'Today',
    read: false,
  },
  {
    id: 2,
    title: 'New User Registered',
    description: "A new user 'John Doe' has signed up and is awaiting approval.",
    type: NOTIFICATION_TYPES.USER,
    time: '15 min ago',
    date: 'Today',
    read: false,
  },
  {
    id: 3,
    title: 'Subscription Expiring',
    description: '3 user subscriptions are expiring within the next 7 days.',
    type: NOTIFICATION_TYPES.WARNING,
    time: '1 hour ago',
    date: 'Today',
    read: true,
  },
  {
    id: 4,
    title: 'User Growth Update',
    description: 'Total users increased by 5 this week. Keep up the momentum!',
    type: NOTIFICATION_TYPES.INFO,
    time: '3 hours ago',
    date: 'Today',
    read: true,
  },
  // Yesterday
  {
    id: 5,
    title: 'System Update',
    description: 'Compatibility AI model has been updated to v2.4.',
    type: NOTIFICATION_TYPES.INFO,
    time: 'Yesterday, 4:30 PM',
    date: 'Yesterday',
    read: true,
  },
  {
    id: 6,
    title: 'New Subscription',
    description: "User 'Sarah Wilson' has upgraded to the Premium plan.",
    type: NOTIFICATION_TYPES.SUCCESS,
    time: 'Yesterday, 2:15 PM',
    date: 'Yesterday',
    read: true,
  },
  {
    id: 7,
    title: 'Failed Payment',
    description: "Payment for user 'Mike Chen' failed. Please review the transaction.",
    type: NOTIFICATION_TYPES.WARNING,
    time: 'Yesterday, 11:00 AM',
    date: 'Yesterday',
    read: true,
  },
  {
    id: 8,
    title: 'New User Registered',
    description: "A new user 'Emily Davis' has signed up via referral link.",
    type: NOTIFICATION_TYPES.USER,
    time: 'Yesterday, 9:45 AM',
    date: 'Yesterday',
    read: true,
  },
  // Feb 28
  {
    id: 9,
    title: 'Prediction Accuracy Report',
    description: 'Weekly prediction accuracy is 94.2%, up from 91.8% last week.',
    type: NOTIFICATION_TYPES.INFO,
    time: 'Feb 28, 5:00 PM',
    date: 'Feb 28',
    read: true,
  },
  {
    id: 10,
    title: 'Chat AI Usage Spike',
    description: 'Chat AI usage increased by 45% compared to last week. Server resources are stable.',
    type: NOTIFICATION_TYPES.INFO,
    time: 'Feb 28, 3:20 PM',
    date: 'Feb 28',
    read: true,
  },
  {
    id: 11,
    title: 'Revenue Alert',
    description: 'Daily revenue dropped below $100 threshold. Review the transactions dashboard.',
    type: NOTIFICATION_TYPES.WARNING,
    time: 'Feb 28, 10:00 AM',
    date: 'Feb 28',
    read: true,
  },
  // Feb 27
  {
    id: 12,
    title: 'New User Registered',
    description: "A new user 'Alex Kim' has signed up and completed onboarding.",
    type: NOTIFICATION_TYPES.USER,
    time: 'Feb 27, 6:30 PM',
    date: 'Feb 27',
    read: true,
  },
  {
    id: 13,
    title: 'Subscription Renewed',
    description: '12 users have successfully renewed their subscriptions this week.',
    type: NOTIFICATION_TYPES.SUCCESS,
    time: 'Feb 27, 2:00 PM',
    date: 'Feb 27',
    read: true,
  },
  {
    id: 14,
    title: 'Compatibility AI Update',
    description: 'New matching algorithm deployed. Compatibility scores may slightly differ.',
    type: NOTIFICATION_TYPES.INFO,
    time: 'Feb 27, 11:30 AM',
    date: 'Feb 27',
    read: true,
  },
  // Feb 26
  {
    id: 15,
    title: 'Security Alert',
    description: 'Unusual login attempt detected for admin account from new IP address.',
    type: NOTIFICATION_TYPES.WARNING,
    time: 'Feb 26, 8:00 PM',
    date: 'Feb 26',
    read: true,
  },
];
